// /pages/InviteMembers.js
import React, { useEffect, useState } from "react";
import { db, auth } from "../../../config/firebaseConfig";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import "./InviteMembers.css";

// 招待コード生成関数
const generateInviteCode = () => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let code = "";
  for (let i = 0; i < 12; i++) {
    code += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return code;
};


const InviteMembers = () => {
  const [projectID] = useState(localStorage.getItem("currentProjectID"));
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [inviteCode, setInviteCode] = useState("");
  const [projectName, setProjectName] = useState("");
  const [userName, setUserName] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProjectData = async () => {
      if (!projectID) return setLoading(false);

      const user = auth.currentUser;
      if (!user) return setLoading(false);

      try {
        const projectRef = doc(db, "projects", projectID);
        const projectSnap = await getDoc(projectRef);
        if (!projectSnap.exists()) return setLoading(false);

        const data = projectSnap.data();
        setInviteCode(data.inviteCode || "");
        setProjectName(data.name || "");

        // 管理者チェック
        const userRef = doc(db, "users", user.uid);
        const userSnap = await getDoc(userRef);
        const userData = userSnap.data();
        setUserName(userData?.displayName || userData?.name || "プロジェクト管理者");

        if (user.uid === data.createdBy || userData.role === "admin") {
          setIsAuthorized(true);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false); // ← 読み込み終了
      }
    };

    fetchProjectData();
  }, [projectID]);

  // ✅ メール文章生成処理
  const handleGenerateInviteEmail = async () => {
    let code = inviteCode;
    const projectRef = doc(db, "projects", projectID);

    // まだコードがない場合は生成
    if (!code) {
      code = generateInviteCode();
      await updateDoc(projectRef, { inviteCode: code });
      setInviteCode(code);
    }

    // 現在の環境（localhost / Firebase）に応じてURLを自動生成
    const inviteLink = `${window.location.origin}/join?code=${code}`;

    // メール文章テンプレート
    const emailText = `
    ${userName} さんから、プロジェクト「${projectName}」への招待が届いています。

    以下のリンクをクリックして、プロジェクトに参加してください。

    🔗 参加リンク：
    ${inviteLink}

    招待コード：${code}

    ※ このリンクをクリックすると、ログイン画面または参加画面が開きます。
    ※ 初めて利用される場合は、Googleログイン後に自動で参加が完了します。
    `;

    try {
      await navigator.clipboard.writeText(emailText);
      alert("📋 メール文章をコピーしました。メールに貼り付けて送信してください。");
    } catch (err) {
      console.error("クリップボードコピーに失敗:", err);
      alert("コピーに失敗しました。手動でコピーしてください。");
    }
  };
  if (loading) return <p className="invite-container">読み込み中…</p>;
  if (!isAuthorized) return <p className="invite-container">このページにはアクセスできません。</p>;

  return (
    <div className="invite-container">
      <h2>プロジェクトメンバーの招待</h2>
      <h3>プロジェクト名： {projectName}</h3>

      <div style={{ marginTop: "1rem" }}>
        <button onClick={handleGenerateInviteEmail}>📧 招待メール文章の作成</button>

        {inviteCode && (
          <div style={{ marginTop: "1rem" }}>
            <p>
              招待コード: <strong>{inviteCode}</strong>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default InviteMembers;
